// extracted by mini-css-extract-plugin
export default {"returnToAdmin":"styles_returnToAdmin__aeLN-","icon":"styles_icon__Hhp2l"};